module.exports = __webpack_public_path__ + "6f367510e707574b0a83eba32b0727ae.svg";